import { render, staticRenderFns } from "./ViewTasks.vue?vue&type=template&id=022e7c7e&scoped=true&"
import script from "./ViewTasks.vue?vue&type=script&lang=js&"
export * from "./ViewTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e7c7e",
  null
  
)

export default component.exports